// FIXME: @sara Check and remove non-used functions
// eslint-disable-next-line @typescript-eslint/no-var-requires
const CryptoJS = require('crypto-js');
import { CATERING } from '../constants';
class SharedUtils {
    static dec2hex(dec) {
        return dec.toString(16).padStart(2, '0');
    }
    // generateId :: Integer -> String
    static generateId(len) {
        var arr = new Uint8Array((len + 1 || 40) / 2);
        window.crypto.getRandomValues(arr);
        return Array.from(arr, this.dec2hex).join('');
    }
    static encryptionFlow() {
        let codeVerifier = this.generateId(45);
        let codeChallenge = this.generateCodeChallenge(codeVerifier);
        return { codeVerifier, codeChallenge };
    }
    static generateCodeChallenge(code_verifier) {
        return this.base64URL(CryptoJS.SHA256(code_verifier));
    }
    static base64URL(string) {
        return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    }
    static parseJwt(token) {
        let base64Payload = token?.split('.')[1];
        var payload = base64Payload ? Buffer.from(base64Payload, 'base64') : '';
        return (payload && JSON.parse(payload.toString())) || payload;
    }
    static flatGoogleAddress(addressComponents, filterby) {
        return addressComponents.reduce((obj, item) => {
            item.types.forEach((t) => (obj[t] = item[filterby]));
            return obj;
        }, {});
    }
    static getCustomerIdFromToken(token = null) {
        let parsedToken = null;
        if (token && token.length > 0) {
            parsedToken = this.parseJwt(token);
        }
        else {
            parsedToken = this.parseJwt('');
        }
        return parsedToken?.sub;
    }
    static getPhoneNumberFromToken(token = null) {
        let parsedToken = null;
        if (token && token.length > 0) {
            parsedToken = this.parseJwt(token);
        }
        else {
            parsedToken = this.parseJwt('');
        }
        return parsedToken?.phone_number;
    }
    static getExpFromToken(token) {
        const parsedToken = this.parseJwt(token);
        return parsedToken?.exp;
    }
    static getIATfromToken(token) {
        const parsedToken = this.parseJwt(token);
        return parsedToken?.iat;
    }
    static getEmailFromToken(token) {
        const parsedToken = this.parseJwt(token);
        return parsedToken?.email;
    }
    static getFirstNameFromToken(token) {
        const parsedToken = this.parseJwt(token);
        return parsedToken?.given_name;
    }
    static getMiddleNameFromToken(token) {
        const parsedToken = this.parseJwt(token);
        return parsedToken?.middle_name;
    }
    static getFamilyNameFromToken(token) {
        const parsedToken = this.parseJwt(token);
        return parsedToken?.family_name;
    }
    static getUserNameFromToken(token) {
        const parsedToken = this.parseJwt(token);
        return parsedToken?.preferred_username;
    }
    static getLoginMethodFromToken(token) {
        const parsedToken = this.parseJwt(token);
        return parsedToken?.login_method;
    }
    static copyObj(obj) {
        return JSON.parse(JSON.stringify(obj) ?? '{}');
    }
    static checkAllTrue(arr) {
        return arr.every((val) => val === true);
    }
    static checkCateringService(service) {
        let serviceFlag = false;
        if (service === CATERING) {
            serviceFlag = true;
        }
        return serviceFlag;
    }
    static futureMenuExclusionCall(exclusionPayload, allowScheduleOrderForDispositions) {
        const { storeId = null, service = null, startDateInEpoch = 0 } = exclusionPayload;
        // eslint-disable-next-line prettier/prettier
        if (allowScheduleOrderForDispositions.includes(service) && storeId && service && startDateInEpoch) {
            return true;
        }
        return false;
    }
}
export default SharedUtils;
